import React from 'react'

function Footer() {
  return (
    <>
      {/* partial:partials/_footer.html */}
        <footer className="footer">
          <div className="d-sm-flex justify-content-center justify-content-sm-between">
            <span className="text-muted d-block text-center text-sm-left d-sm-inline-block">Copyright © Restro 2025</span>
            <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center text-muted"> By Riya Nagar, Vidhi Shah, Hardi Sameja</span>
          </div>
        </footer>
    </>
  )
}

export default Footer
